import React from 'react'
import {Button, Card, CardBody, CardHeader} from 'reactstrap'
import PropTypes from 'prop-types'

class ImportItemsAdd extends React.Component {
    state = {
        Marketplace:'',
        mockUpFront: '',
        mockUpBack: '',
        designFront: '',
        designBack: '',
        size: '',
        type: '',
        color: '',
        orderNumber: '',
        item: '',
        quantity: '',
        name: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        country: '',
        phone: '',
        postalCode: '',
        note: '',
        tags: '',
        return_name: '',
        return_address1: '',
        return_address2: '',
        return_city: '',
        return_state: '',
        return_countryCode: '',
        return_postalCode: '',
        return_email: '',
        return_phone: '',
        product_print_file_json: '',
        thread_color_note: '',
    }

    _handleChangeInput = (e) => {
        const {target: {name, value}} = e
        this.setState({[name]: value})
    }

    _isValidJSON = (text) => {
        try {
            JSON.parse(text)
            return true
        } catch (e) {
            return false
        }
    }

    _handleAddItem = () => {
        const {state: item} = this
        const {product_print_file_json} = {...item}
        if(product_print_file_json && !this._isValidJSON(product_print_file_json)) {
            alert(`product_print_file_json is not valid JSON`)
            return
        }
        this.props.onAddItem(item)
    }

    render() {
        const {Marketplace, mockUpFront, mockUpBack, designFront, designBack, size, type, tags, color, orderNumber, item, quantity, name, address1, address2, city, state, country, phone, postalCode, note, return_name, return_address1, return_address2, return_city, return_state, return_countryCode, return_postalCode, return_email, return_phone, product_print_file_json, thread_color_note} = this.state

        return (
            <div className='ImportItemsAdd mb-3'>
                <Card>
                    <CardHeader>
                        <h4 className='d-flex justify-content-between align-items-center w-100 font-weight-bold mb-3'>
                            <div>Add Item</div>
                        </h4>
                    </CardHeader>
                    <CardBody>
                        <table className='table table-responsive'>
                            <thead>
                                <tr>
                                    <th>marketPlace</th>
                                    <th>mockUpFront</th>
                                    <th>mockUpBack</th>
                                    <th>designFront</th>
                                    <th>designBack</th>
                                    <th>size</th>
                                    <th>type</th>
                                    <th>color</th>
                                    <th>orderNumber</th>
                                    <th>item</th>
                                    <th>quantity</th>
                                    <th>name</th>
                                    <th>address1</th>
                                    <th>address2</th>
                                    <th>city</th>
                                    <th>state</th>
                                    <th>country</th>
                                    <th>phone</th>
                                    <th>postalCode</th>
                                    <th>note</th>
                                    <th>tags</th>
                                    <th>return_name</th>
                                    <th>return_address1</th>
                                    <th>return_address2</th>
                                    <th>return_city</th>
                                    <th>return_state</th>
                                    <th>return_countryCode</th>
                                    <th>return_postalCode</th>
                                    <th>return_email</th>
                                    <th>return_phone</th>
                                    <th>product_print_file_json</th>
                                    <th>thread_color_note</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <input type='text' name='Marketplace' value={Marketplace}
                                            onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='mockUpFront' value={mockUpFront}
                                            onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='mockUpBack' value={mockUpBack}
                                            onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='designFront' value={designFront}
                                            onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='designBack' value={designBack}
                                            onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='size' value={size} onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='type' value={type} onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='color' value={color} onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='orderNumber' value={orderNumber}
                                            onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='item' value={item} onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='quantity' value={quantity}
                                            onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='name' value={name} onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='address1' value={address1}
                                            onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='address2' value={address2}
                                            onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='city' value={city} onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='state' value={state} onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='country' value={country}
                                            onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='phone' value={phone} onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='postalCode' value={postalCode}
                                            onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='note' value={note}
                                            onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='tags' value={tags} onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='return_name' value={return_name} onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='return_address1' value={return_address1}
                                            onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='return_address2' value={return_address2}
                                            onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='return_city' value={return_city} onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='return_state' value={return_state} onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='return_countryCode' value={return_countryCode}
                                            onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='return_postalCode' value={return_postalCode}
                                            onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='return_email' value={return_email} onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='return_phone' value={return_phone} onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='product_print_file_json' value={product_print_file_json} onChange={this._handleChangeInput} />
                                    </td>
                                    <td>
                                        <input type='text' name='thread_color_note' value={thread_color_note} onChange={this._handleChangeInput} />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </CardBody>
                </Card>
                <div className='text-right'>
                    <Button color='primary' onClick={this._handleAddItem}>Add</Button>
                </div>
            </div>
        )
    }
}

ImportItemsAdd.propTypes = {
    onAddItem: PropTypes.func.isRequired
}

export default ImportItemsAdd
